export default __webpack_public_path__ + "static/media/eye-logo.70786e51.jpg";